import { render, staticRenderFns } from "./EditCoursePlan.vue?vue&type=template&id=fea8f32e&scoped=true"
import script from "./EditCoursePlan.vue?vue&type=script&lang=js"
export * from "./EditCoursePlan.vue?vue&type=script&lang=js"
import style0 from "./EditCoursePlan.vue?vue&type=style&index=0&id=fea8f32e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fea8f32e",
  null
  
)

export default component.exports